const e = {
  extends: "Pick3",
  logo: !0
};
export {
  e as default
};
